import { useState, useCallback } from 'react';

const useValidation = (fields, schema) => {
  const [errors, setErrors] = useState({});

  const validate = useCallback(() => {
    const errorMessages = {};

    try {
      schema.validateSync(fields, { abortEarly: false });
    } catch (e) {
      e.inner.forEach(error => {
        errorMessages[error.path] = error.message;
      });
    }

    setErrors(errorMessages);
  }, [fields, schema]);

  const handleChange = useCallback(
    event => {
      const { name, value } = event.currentTarget;
      const sanitizedName = name.replace('[]', '');

      const values = {
        ...fields,
        [sanitizedName]: value,
      };

      try {
        schema.validateSyncAt(sanitizedName, values);

        setErrors(prev =>
          Object.keys(prev)
            .filter(key => key !== sanitizedName)
            .reduce((obj, key) => ({ ...obj, [key]: prev[key] }), {})
        );
      } catch (error) {
        setErrors(prev => ({ ...prev, [name]: error.message }));
      }
    },
    [fields, schema]
  );

  const handleBlur = handleChange;

  const isValid = useCallback(() => schema.isValidSync(fields), [
    fields,
    schema,
  ]);

  return {
    errors,
    setErrors,
    validate,
    handleBlur,
    handleChange,
    isValid,
  };
};

export default useValidation;
